/*
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-08-21 10:51:58
 * @Description:
 * @FilePath: \mobile-revive\src\utils\fetch.js
 */
import axios from 'axios'
import { Notify } from 'vant'
class AjaxRequest {
    constructor() {
    // this.baseURL = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_INTERFACEADDRESS : '/';
        this.baseURL = process.env.VUE_APP_INTERFACEADDRESS
        this.timeout = 5000
    }
    request(config) {
        const instance = axios.create({
            baseURL: this.baseURL,
            timeout: this.timeout
        })
        // 拦截器
        instance.interceptors.request.use((config) => {
        // const token = '4l+7j4Z59690emNyVMq5ILPZ7+JEh2G2ki7nTGCY6Qbbu4N2S2iJYsupCGFhPiJFZk1wcilnDwVMqKj1ea4LJA==';
            const token = sessionStorage.ddToken
            config.headers['Authorization'] = 'Bearer ' + token
            config.headers.start = (new Date()).valueOf()
            return config
        },
        err => Promise.reject(err))
        // 响应拦截器
        instance.interceptors.response.use(res => {
            res.headers.end = (new Date()).valueOf()
            const path = res.config.url.split('?')[0]
            const interval = (res.headers.end - res.config.headers.start)
            const value = res.config.url + '-' + res.status
            let _paq = window._paq
            _paq.push(['trackEvent', 'API监控-正常', path, value, interval])
            return res.data.body.content
        }, err => {
            if (err && err.response) {
                switch (err.response.status) {
                case 400:
                    err.message = err.response.data.message
                    break
                case 401:
                    Notify({ type: 'danger', message: '会话已超时，请关闭页面重新进入' })
                    break
                case 403:
                    Notify({ type: 'danger', message: '拒绝访问' })
                    // error.message = '拒绝访问'
                    break
                case 404:
                    Notify({ type: 'danger', message: `请求地址出错: ${err.response.config.url}` })
                    // error.message = `请求地址出错: ${error.response.config.url}`
                    break
                case 408:
                    Notify({ type: 'danger', message: '请求超时' })
                    // error.message = '请求超时'
                    break
                case 500:
                    Notify({ type: 'danger', message: '服务器内部错误' })
                    // error.message = '服务器内部错误'
                    break
                case 501:
                    Notify({ type: 'danger', message: '服务未实现' })
                    // error.message = '服务未实现'
                    break
                case 502:
                    Notify({ type: 'danger', message: '网关错误' })
                    // error.message = '网关错误'
                    break
                case 503:
                    Notify({ type: 'danger', message: '服务不可用' })
                    // error.message = '服务不可用'
                    break
                case 504:
                    Notify({ type: 'danger', message: '网关超时' })
                    // error.message = '网关超时'
                    break
                case 505:
                    Notify({ type: 'danger', message: '拒绝访问' })
                    // error.message = 'HTTP版本不受支持'
                    break
                default:
                    err.message = err.response.message
                    break
                }
            }
            err.config.headers.end = (new Date()).valueOf()
            const path = err.config.url.split('?')[0]
            const interval = (err.config.headers.end - err.config.headers.start) / 1000
            const value = err.config.url + '-' + err.status
            if (err.response && err.response.status != 401) {
                let _paq = window._paq
                _paq.push(['trackEvent', 'API监控-异常', path, value, interval])
            }
            return Promise.reject(err.response)
        })
        return instance(config)
    }
}
// 使用实例 .request({url:url})
export default new AjaxRequest()
